



import { Vue, Component } from "vue-property-decorator"
// const appInfo = require("../../package.json")
import appInfo from "package.json"

@Component
export default class AppFooter extends Vue {
  get version() {
    return appInfo.version
  }
}
